import { render } from "./faltan.vue?vue&type=template&id=79797c36&scoped=true"
import script from "./faltan.vue?vue&type=script&lang=js"
export * from "./faltan.vue?vue&type=script&lang=js"

import "./faltan.vue?vue&type=style&index=0&id=79797c36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79797c36"]])

export default __exports__